/* tslint:disable */
import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpService} from "../http.service";
import * as THREE from 'three';
import {MeshService} from "./views/three-dview/mesh.service";
import {WebGLService} from "./views/three-dview/web-gl.service";
import {ImageDrawingInfo} from "./views/two-dview/twoDViewModels";
import {TwoDService} from "./views/two-dview/two-d.service";
import {Location} from "@angular/common";
import {BehaviorSubject} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BrainService {

    urlLoadBrainData = environment.apiURL + 'load_brain_data';
    urlLoad2DBrainData = environment.apiURL + 'load_2D_brain_data';
    urlLoad3DBrainData = environment.apiURL + 'load_3D_brain_data';
    subjectIsBrainDataLoaded = new BehaviorSubject(false);
    brainData = {
        isLoaded: false,
        is2DDataLoaded: false,
        is3DDataLoaded: false
    };

    brainMaterialFibers;
    brainMaterialCellBodies;
    brainMaterialOutline;

    brain3DModel;
    brain2DModel;

    isBrainReady = false;

    brainModelsVariables = {
        _3D: {
            defaultOpacity: 0.2,
            defaultRotationSpeed: 0.05,
            brainClippingPlanesDictionary: null,
            brainClippingPlanesArray: [],
            brainGroup: null
        }
    }

    constructor(private httpService: HttpService,
                private webGLService: WebGLService,
                private twoDService: TwoDService,
                private drawerService: MeshService) {
        console.log("................::::::::constructor loadBrainData():::::::.............");
        this.loadBrainData();
    }

    loadBrainData() {
        if (!this.brainData.isLoaded) {
            this.httpService.postRequest(this.urlLoadBrainData, {}).subscribe((response) => {
                this.brainData = response['data'];
                this.brainData.isLoaded = true;
                this.subjectIsBrainDataLoaded.next(this.brainData.isLoaded);

                //3D
                this.brain3DModel = this.brainData['threeD'];

                this.initBrain3DMesh();

                //2D
                this.brain2DModel = this.brainData['twoD'];
                this.brain2DModel.drawingInfo = new ImageDrawingInfo(this.brain2DModel.visualization_data._2d, this.brain2DModel.visualization_data.color, false);
                this.brain2DModel.drawingInfo.show = true;

                this.addBrainTo2DScene();
            });
        }
    }

    //region 3D

    createBrainSliceMaterial(brainSlice) {
        if (this.brainModelsVariables._3D.brainClippingPlanesDictionary === null || this.brainModelsVariables._3D.brainClippingPlanesDictionary === undefined) {
            this.brainModelsVariables._3D.brainClippingPlanesDictionary =
                {
                    top: new THREE.Plane(new THREE.Vector3(0, 1, 0), 800),
                    bottom: new THREE.Plane(new THREE.Vector3(0, -1, 0), 800),
                    left: new THREE.Plane(new THREE.Vector3(-1, 0, 0), 500),
                    right: new THREE.Plane(new THREE.Vector3(1, 0, 0), 500),
                    front: new THREE.Plane(new THREE.Vector3(0, 0, -1), 500),
                    back: new THREE.Plane(new THREE.Vector3(0, 0, 1), 500)
                };

            this.brainModelsVariables._3D.brainClippingPlanesArray = [
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.top,
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.bottom,
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.left,
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.right,
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.front,
                this.brainModelsVariables._3D.brainClippingPlanesDictionary.back,
            ];

        }
        return new THREE.MeshPhongMaterial({
            wireframe: false,
            color: brainSlice.visualization_data.color,
            transparent: true,
            opacity: this.brainModelsVariables._3D.defaultOpacity,
            depthTest: false,
            clippingPlanes: this.brainModelsVariables._3D.brainClippingPlanesArray,
            clipShadows: true,
        });
    }

    createBrainMaterials() {
        this.brain3DModel.brainIntersections = [];
        this.brainModelsVariables._3D.brainGroup = new THREE.Group();

        this.brainMaterialFibers = this.createBrainSliceMaterial(this.brain3DModel.fibers);
        this.brainMaterialCellBodies = this.createBrainSliceMaterial(this.brain3DModel.cell_bodies);
        this.brainMaterialOutline = this.createBrainSliceMaterial(this.brain3DModel.outline);
    }


    async initBrain3DMesh() {
        console.log("................::::::::initBrain3DMesh::::::::..................");
        this.brain3DModel.brainIntersections = [];
        this.brainModelsVariables._3D.brainGroup = new THREE.Group();

        let brainMaterialFibers = this.createBrainSliceMaterial(this.brain3DModel.fibers);

        this.brain3DModel.fibers.mesh = await this.drawerService.loadSTLFile(this.brain3DModel.fibers.visualization_data._3d.mesh_file, brainMaterialFibers);

        let brainMaterialCellBodies = this.createBrainSliceMaterial(this.brain3DModel.cell_bodies);
        this.brain3DModel.cell_bodies.mesh = await this.drawerService.loadSTLFile(this.brain3DModel.cell_bodies.visualization_data._3d.mesh_file, brainMaterialCellBodies);

        let brainMaterialOutline = this.createBrainSliceMaterial(this.brain3DModel.outline);
        this.brain3DModel.outline.mesh = await this.drawerService.loadSTLFile(this.brain3DModel.outline.visualization_data._3d.mesh_file, brainMaterialOutline);

        this.brain3DModel.center = this.drawerService.getMeshCenter(this.brain3DModel.outline.mesh);
        // console.log(" this.brain3DModel.center ==>", this.brain3DModel.center);
        // Without an additional 100 pixels added to the y-axis, the lower part of the brain would become hidden.
        this.brain3DModel.center.y += 100;

        this.webGLService.referencePosition = this.brain3DModel.center;

        // Move the brain mesh to the center of the Brain group (The centers will become identical)
        this.brain3DModel.fibers.mesh.position.sub(this.brain3DModel.center);
        this.brain3DModel.cell_bodies.mesh.position.sub(this.brain3DModel.center);
        this.brain3DModel.outline.mesh.position.sub(this.brain3DModel.center);
        this.brain3DModel.outline.selected = true;

        this.brainModelsVariables._3D.brainGroup.add(this.brain3DModel.outline.mesh);

        this.resetBrainRotation();

        this.brain3DModel.brainIntersections.push(this.brain3DModel.outline.mesh);

        this.webGLService.mouseIntersections.push(this.brain3DModel.outline.mesh);

        this.webGLService.addToScene(this.brainModelsVariables._3D.brainGroup);
        this.isBrainReady = true;

        this.webGLService.resize();
    }

    resetBrainRotation() {
        this.brain3DModel.rotations = {};
        this.brain3DModel.rotations.x = false;
        this.brain3DModel.rotations._x = false;
        this.brain3DModel.rotations.y = false;
        this.brain3DModel.rotations._y = false;
        this.brain3DModel.rotations.z = false;
        this.brain3DModel.rotations._z = false;

        this.brain3DModel.rotations.is_infinit = true;
        this.brain3DModel.rotations.max_angle = 0;
        this.brain3DModel.rotations.current_angle = 0;

        this.brainModelsVariables._3D.brainGroup.rotation.x = 0;//Math.PI / 50;
        this.brainModelsVariables._3D.brainGroup.rotation.y = 0;
        this.brainModelsVariables._3D.brainGroup.rotation.z = 0;//3.14;

        // $rootScope.reset_controls($rootScope.brain_group.position);
    };

    changeBrainSliceSelection(brainSlice) {
        if (brainSlice.selected) {
            this.brainModelsVariables._3D.brainGroup.add(brainSlice.mesh);
            this.brain3DModel.brainIntersections.push(brainSlice.mesh);
        } else {
            this.brainModelsVariables._3D.brainGroup.remove(brainSlice.mesh);
            this.brain3DModel.brainIntersections.splice(this.brain3DModel.brainIntersections.indexOf(brainSlice.mesh), 1);
        }
    };

    //endregion

    //region 2D

    addBrainTo2DScene() {
        this.twoDService.addNonSplitImageTo2DScene(this.brain2DModel.drawingInfo);
    }

    removeBrainTo2DScene() {
        this.twoDService.removeNonSplitImageFrom2DScene(this.brain2DModel.drawingInfo);
    }

    //endregion
}
